/**
 * Akce pro číselník štítků šablon.
 */
import {list} from './..'
import ObalkaApi from "mc/lib/api/gen/obalky/ObalkaApi";
import * as SharedActions from "./../shared/SharedActions"

function getList() {
    return ObalkaApi.getSablony()
        .then(data => ({rows: data, count: 0}));
}

export function fetchListIfNeeded(area) {
    return (dispatch, getState) => {
        dispatch(SharedActions.initIfNeeded(area, list.SimpleListReducer));

        dispatch(list.SimpleListActions.fetchIfNeeded(area, null, () => {
            return getList()
        }));
    }
}
